import styled from 'styled-components';

import StopAddress from './container';

export default styled(StopAddress)`
  position: relative;

  &.isFocused {
    border-left-color: var(--primary500);
  }
  &.hasError {
    border-bottom: 4px solid var(--error700);
  }

  background: var(--white);
  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: var(--grey300);
  border-radius: 4px;
  width: 100%;

  .stop-address__input {
    padding-left: 48px;
    padding-right: 48px;
    input {
      border: none;
      outline: none;
      box-shadow: none;
    }
  }
`;
